// extracted by mini-css-extract-plugin
export default {"content":"Privacy_content__xb03V"};